import { HeaderModalSort } from "@/components/shared/header-modal-sort";
import { AccountsOrderBy } from "@/graphql/codegen/graphql";
import { cn } from "@/utils/lib";

export const FeedSearchUserTopActions = ({
  onSortChange,
  orderBy,
}: {
  onSortChange: (orderBy: string) => void;
  orderBy: string;
}) => {
  const sortOptions = [
    {
      value: AccountsOrderBy.TotalBalanceUsdCentsDesc,
      label: "Total Assets (High to Low)",
    },
    {
      value: AccountsOrderBy.TotalBalanceUsdCentsAsc,
      label: "Total Assets (Low to High)",
    },
  ];

  return (
    <div
      className={cn(
        `
          z-20 -mb-1 flex animate-fade items-center justify-between border-b
          border-border-light bg-background/10 px-4 py-2 text-xs opacity-0
          backdrop-blur-md fade-in-100 fill-mode-forwards
        `,
      )}
    >
      <HeaderModalSort {...{ sortOptions, onSortChange }} value={orderBy} />
    </div>
  );
};
